// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"vendors-node_modules_xlsx_xlsx_mjs":"2674dd6ae75ceb08dcb7","_2718":"874a052ebba5adb1d3c9"}[chunkId] + ".js";
};